import { compareMachineTypeOrder } from "utils/localMachineOrder";

const typeIdCollator = new Intl.Collator("es", { numeric: true });

export default function groupAvailableMachines(machines) {
  const groupsById = new Map();

  machines.forEach((machine) => {
    const typeId = machine.MachineType?.Id ?? null;
    const key = typeId === null ? "unassigned" : `type:${typeId}`;
    if (!groupsById.has(key)) {
      groupsById.set(key, {
        key,
        typeId,
        title: typeId === null ? "No asignado" : machine.MachineType.Type || "No asignado",
        machines: [],
      });
    }
    groupsById.get(key).machines.push(machine);
  });

  return [...groupsById.values()].sort((a, b) => {
    if (a.title === "No asignado" && b.title !== "No asignado") return 1;
    if (b.title === "No asignado" && a.title !== "No asignado") return -1;
    if (a.typeId === null) return 1;
    if (b.typeId === null) return -1;
    return (
      compareMachineTypeOrder(a.title, b.title) ||
      typeIdCollator.compare(String(a.typeId), String(b.typeId))
    );
  });
}
